module.exports = __webpack_public_path__ + "img/Temperature_small.5cf6b504.svg";